import styled, { css, keyframes } from 'styled-components';
import { ifProp } from 'styled-tools';
import media from 'themes/media';

const slideBottom = keyframes`
  0% {
  transform: translateY(-400px);
  }
  100% {
  transform: translateY(0);
  }
`;

export const MenuContainer = styled.div`
  display: flex;
  flex-direction: column;
  background: #ffffff;
  max-height: 100vh;
  height: ${(props) => props.theme.sizing.menuHeight};
  position: absolute;
  top: 0;
  right: 0;
  z-index: 999;
  left: 0;

  ${media.greaterThan('desktop')`
    position: static;
    width: ${(props) => props.theme.sizing.menuWidth};
    flex-shrink:0;
    min-height: 100vh;
    border-right: ${(props) => props.theme.colors.background.borderColor};
  `}

  ${media.lessThan('tablet')`
    height: 60px;
  `}
`;

export const MenuHeader = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: space-between;

  background: ${(props) => props.theme.colors.background.menuBodyColor};
  padding: 15px;
  border-bottom: 1px solid
    ${(props) => props.theme.colors.background.borderColor};
  z-index: 999;

  ${media.greaterThan('desktop')`
    padding-left: 30px
  `}
`;

export const HeaderSwitchAccountTypeWrapper = styled.div`
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  display: none;

  @media (max-width: 1399px) and (min-width: 450px) {
    display: ${ifProp('show', 'block', 'none')};
  }
`;

export const MenuBody = styled.div`
  display: flex;
  flex-direction: column;
  position: absolute;
  z-index: 990;
  top: ${(props) => props.theme.sizing.menuHeight};
  right: 0;
  width: 320px;
  /* height: ${(props) => `calc(100vh -  ${props.theme.sizing.menuHeight})`}; */
  border-bottom: 1px solid
    ${(props) => props.theme.colors.background.borderColor};
  transform: translateY(-1000px);
  transition: all 0.3s linear;

  background: ${(props) => props.theme.colors.background.menuBodyColor};

  animation: ${(props) =>
    props.isOpen
      ? css`
          ${slideBottom} 0.3s cubic-bezier(0.250, 0.460, 0.450, 0.940) both;
        `
      : ''};

  ${media.greaterThan('desktop')`
    position: static;
    transform: none;
    border-bottom:none;
    flex-grow:1;
    width: auto;
  `}

  ${media.lessThan('tablet')`
    top: 60px;
  `}
`;

export const Logo = styled.div`
  display: flex;
  align-items: center;
`;

export const LogoImg = styled.img`
  position: relative;
  width: ${ifProp('isMobile', 68, 150)}px;
  cursor: pointer;
`;

export const Hamburger = styled.div`
  display: flex;
  margin-left: 16px;
  cursor: pointer;
  transition: all 0.3s linear;

  ${media.greaterThan('desktop')`
    display: none;
  `}
`;

export const LogoutContainer = styled.div`
  border-top: ${(props) =>
    `1px solid ${props.theme.colors.background.borderColor}` || ''};
  cursor: pointer;
  padding: 16px 0;
  display: flex;
  justify-content: center;
  margin-top: auto;

  color: ${(props) => props.theme.colors.text.textColorLogout};
  font-weight: ${(props) => props.theme.assets.fonts.fontWeight};
  width: ${(props) => props.theme.sizing.logoutWidth || ''};
  border-radius: ${(props) => props.theme.sizing.borderRadius};
  // margin: auto;

  @media (max-width: 375px) {
    padding: 7px ${(props) => props.theme.sizing.menuPadding};
  }
`;

export const Overlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: black;
  opacity: 0.5;
  z-index: 990;
`;

export const HeaderTitle = styled.h3`
  margin: 0 20px;
  text-align: center;
  flex: 1;
  font-weight: 500;
  font-size: 16px;

  ${media.greaterThan('tablet')`
    display: none;
  `}
`;

export const MenuSide = styled.div`
  display: flex;
  align-items: center;
`;

export const LanguageSwitcherWrapper = styled.div`
  ${media.greaterThan('desktop')`
    display: none;
  `}
`;
